import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { insideItems } from '../data/gallery';
import { VISUAL_IMAGE, VISUAL_IMAGE_ALT } from '../data/offer';
const imagine = ['Imagine explaining the threading path with one clear, numbered visual.', 'Walking students through a skirt block draft with real measurements.', 'Showing a crooked and a perfect centered zipper side by side.', 'Reading the wrinkles on a toile and knowing exactly which adjustment fixes them.', 'And connecting every technique to a clean, professional finished garment.'];
export function VisualSection() {
  return <section className="py-20 px-4 bg-white" data-id="element-332" data-mp="3gbik15t8i91g">
      <div className="max-w-5xl mx-auto" data-id="element-333" data-mp="3l8io5b6ix1px">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="grid md:grid-cols-[1fr_1.4fr] gap-8 md:gap-12 items-start" data-id="element-334" data-mp="3l9a9zuabjl30">
          <div data-id="element-335" data-mp="eq0sujzmxu36">
            <h2 className="text-3xl md:text-4xl font-bold tracking-tight mb-5 text-[#520128] uppercase" data-id="element-336" data-mp="eton5lcwmkiy">
              See What You&apos;re Teaching
            </h2>
            <p className="text-xl font-semibold text-[#520128] mb-1" data-id="element-337" data-mp="nqyy15lt87nc">Sewing Is Hard to Explain With Words.</p>
            <p className="text-xl font-semibold text-[#8E2C5C] mb-5" data-id="element-338" data-mp="jr6mck14dldr">
              Your Teaching Materials Shouldn&apos;t Be.
            </p>
            <div className="space-y-3 text-slate-700 leading-relaxed" data-id="element-339" data-mp="3n7drkuz6nqon">
              <p data-id="element-340" data-mp="3n988zzb8x0nz">{imagine.join(' ')}</p>
              <p className="font-semibold text-[#520128]" data-id="element-341" data-mp="4t5xub2kmbtn">
                That&apos;s the advantage of a 100% visual training system.
              </p>
              <p data-id="element-342" data-mp="1ecqg26oyaw">
                <span className="font-semibold text-[#8A6A2B]" data-id="element-343" data-mp="uv70gg4bxe">SEWING &amp; PATTERN MAKING INSTRUCTOR ATLAS</span> is
                built around illustrations, labeled diagrams, construction sequences, numbered breakdowns, ❌/✅
                comparisons, teaching cues, drills and quick checks.
              </p>
            </div>
          </div>

          <div className="bg-[#F8F3EC] border border-[#E6D5BF] rounded-2xl p-6" data-id="element-344" data-mp="1ceb5cgjn1mgg">
            <p className="text-sm font-bold text-[#8A6A2B] uppercase tracking-wider mb-4" data-id="element-345" data-mp="1h5jh3j8fxjws">
              Inside you’ll find:
            </p>
            <ul className="grid sm:grid-cols-2 gap-x-4 gap-y-2.5" data-id="element-346" data-mp="1m4mohabw827x">
              {insideItems.map(item => <li key={item} className="flex items-start gap-2 text-sm text-slate-700" data-id="element-347" data-mp="oji820lj1y7s">
                  <CheckCircle2 size={16} className="text-[#8E2C5C] shrink-0 mt-0.5" data-id="element-348" data-mp="tgqsy8y28gcq" />
                  <span data-id="element-349" data-mp="ye0dpbai83u8">{item}</span>
                </li>)}
            </ul>
          </div>
        </motion.div>

        <motion.img initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} src={VISUAL_IMAGE} alt={VISUAL_IMAGE_ALT} loading="lazy" className="w-full max-w-2xl h-auto mx-auto mt-12 rounded-2xl border border-[#E6D5BF] shadow-lg shadow-[#520128]/10" data-id="element-350" data-mp="13clfvg9bgxlb" />

        <p className="text-center text-2xl md:text-4xl font-extrabold tracking-tight text-[#520128] mt-14" data-id="element-351" data-mp="3plj60a1it59u">
          <span className="text-[#8E2C5C]" data-id="element-352" data-mp="3knrf9jcm3p78">100% VISUAL.</span> PRACTICAL. PROFESSIONAL.{' '}
          <span className="bg-[#520128] text-white px-2 box-decoration-clone" data-id="element-353" data-mp="3foej27zup5rz">BUILT TO TEACH.</span>
        </p>
      </div>
    </section>;
}